var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.276,
    height: 19.172,
    viewBox: "0 0 19.276 19.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27639",
    "data-name": "Path 27639",
    d: "M178,108.859h9.33l-2.371,2.371a.836.836,0,1,0,1.182,1.182l3.8-3.8a.874.874,0,0,0,.1-.126c.008-.012.013-.025.02-.037a.863.863,0,0,0,.057-.106c.007-.018.011-.036.017-.054a.866.866,0,0,0,.031-.1.825.825,0,0,0,0-.331.781.781,0,0,0-.031-.1c-.006-.018-.009-.037-.017-.054a.85.85,0,0,0-.057-.106c-.007-.012-.013-.025-.02-.037a.862.862,0,0,0-.1-.126l-3.8-3.8a.836.836,0,1,0-1.182,1.182l2.37,2.37H178a5.579,5.579,0,0,0-5.573,5.573.836.836,0,0,0,1.672,0,3.906,3.906,0,0,1,3.9-3.9Zm12.868,3.5a.836.836,0,0,0-.836.836,3.905,3.905,0,0,1-3.9,3.9H176.8l2.371-2.371a.836.836,0,0,0-1.182-1.182l-3.8,3.8a.873.873,0,0,0-.1.126c-.007.011-.013.024-.019.036a.767.767,0,0,0-.057.107c-.007.017-.01.036-.017.053a.917.917,0,0,0-.031.1.825.825,0,0,0,0,.331.777.777,0,0,0,.031.1c.006.018.009.036.017.053a.842.842,0,0,0,.057.107c.007.011.012.024.019.036a.862.862,0,0,0,.1.126l3.8,3.8a.836.836,0,1,0,1.182-1.182l-2.37-2.37h9.33a5.579,5.579,0,0,0,5.573-5.573.836.836,0,0,0-.836-.836Z",
    transform: "translate(-172.431 -103.39)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.4b4c05a8b4345a2cbbc97cbb521012e4.svg";
export { ForwardRef as ReactComponent };